import { useEffect, useState } from 'react';
import { ProcessingOverlay } from 'common/components/UI/ProcessingOverlay';
import { Api } from 'common/utils/api';

// JWKS public endpoint
export const JwksPublic = () => {
    const [jwks, setJwks] = useState(JSON);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchJwks = async () => {
            const jwksResponse = await Api.get<JSON>({ path: `/jwks` });
            setJwks(jwksResponse);
            setLoading(false);
        };

        fetchJwks();
    }, []);

    if (loading) {
        return <ProcessingOverlay enabled caption="Fetching JWKS..." />;
    }

    return <pre>{JSON.stringify(jwks)}</pre>;
};
